import { forwardRef, ReactNode } from 'react';
import { IconCalendarOutline } from '@iwoca/icons';
import { Input } from '@iwoca/orion';
import styles from './DateFieldInput.module.css';

type TProps = {
  label: ReactNode;
  error?: ReactNode;
  displayValue: string;
  onClick?: () => void;
  disabled?: boolean;
};

export const DateFieldInput = forwardRef<HTMLInputElement, TProps>(
  ({ label, error, displayValue, onClick, disabled }, ref) => (
    <Input
      ref={ref}
      label={label}
      error={error}
      iconLeft={<IconCalendarOutline />}
      value={displayValue}
      placeholder="DD/MM/YYYY"
      onClick={onClick}
      disabled={disabled}
      readOnly
      className={styles.input}
      data-testid="date-field-input"
    />
  ),
);

DateFieldInput.displayName = 'DateFieldInput';
